import React, {
  useState,
  useRef,
  useEffect,
  KeyboardEvent,
  ChangeEvent,
} from "react";

import { Button, Card, CardBody, CardHeader, Form, Nav } from "react-bootstrap";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import * as functions from "./moduleFunctions";
import * as myTreeIcons from "../../images/icons/treeicons";
import { kamerItem } from "../../Shared/sharedInterfaces";
import {
  dbItem,
  outputOptions,
  ModuleTypes,
  WebsiteCategories,
  TreeIOs,
} from "../../Shared/sharedInterfaces";
import { ThemeProvider, createTheme } from "@mui/material";
import "./outputmodules.css";
import IoName from "./ioname";
import DmxOptions from "./dmx";
import QdmOptions from "./qdm";
import ModulesContext from "./contextMenu";
import Errors from "../../Screens/error";
import { getTranslations } from "../../Shared/translations";
import moduleAliasConfig from "../config/exceptions/moduleAliasConfig.json";

const MODULE_DISPLAY_NAMES: Record<string, string> =
  moduleAliasConfig.displayByRealName;
// Reverse map: display label → real database name
const MODULE_REAL_NAMES: Record<string, string> = Object.fromEntries(
  Object.entries(MODULE_DISPLAY_NAMES).map(([real, display]) => [display, real]),
);
const IO_OUTPUTS_PER_TYPE: Record<string, number> =
  moduleAliasConfig.ioOutputsPerType ?? {};

const getConfiguredIoOutputCount = (type: string): number | undefined => {
  const normalized = String(type || "").toUpperCase();
  const count = IO_OUTPUTS_PER_TYPE[normalized];
  return typeof count === "number" && count > 0 ? count : undefined;
};

// Module add behavior:
// false = add 1 output per selected module (previous behavior)
// true = add max available outputs per selected module
const ADD_MAX_OUTPUTS_PER_MODULE = false;

interface MyProps {
  woningSlectedId: { id: string; type: string; label: string };
  addToParentDb: (itemst: any) => any;
  uitvoering: string;
  ctdId: Number;
  kastId: Number;
}

const OutputModulesTree = ({
  woningSlectedId,
  addToParentDb,
  uitvoering,
  ctdId,
  kastId
}: MyProps) => {
  //console.log("🔁 Outputmodules rendered");
  //console.log("ctdId: ", ctdId)
  //console.log("kastId: ", kastId)
  
  const [inputs, setInputs] = useState<kamerItem[]>([]);
  const [outputs, setOutputs] = useState<kamerItem[]>([]);
  const [selectedView, setSelectedView] = useState<ViewType | "">("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorsVisible, setErrorsVisible] = useState<boolean>(false);
  const [dmxVisible, setDmxVisible] = useState(false);
  const [qdmVisible, setQdmVisible] = useState(false);
  const [treeItemsArray, setTreeItemsArray] = useState<any[]>([]);
  const [myNodeId, setMyNodeId] = useState<any>(null);
  const [ruimteNaam, setRuimteNaam] = useState<string>("");
  const [, setNaamText] = useState<string>("");

  

  const [context, setContext] = useState(false);
  const [xyPosition, setxyPosition] = useState({ x: 0, y: 0 });
  const [contextItem, setContextItem] = useState<kamerItem>({
    id: "",
    key: "",
    name: "",
    nodeid: "",
  });

  const [ioType, setioType] = useState<string>("io");

  const [inputItemsFiltered, setInputItemsFiltered] = useState<kamerItem[]>([]);
  const [newInputItemsFiltered, setNewInputItemsFiltered] = useState<TreeIOs[]>(
    [],
  );

  const treeItemCounter = useRef(0);
  const dmxAantalRef = useRef(1);
  const qdmAantalRef = useRef(1);

  const outputItems: kamerItem[] = JSON.parse(
    sessionStorage.getItem("modulesOutputs") || "{}",
  );

  const inputItems: kamerItem[] = JSON.parse(
    sessionStorage.getItem("modulesInputs") || "{}",
  );

  const outputItems2: TreeIOs[] = JSON.parse(
    sessionStorage.getItem("modulesOutputs") || "{}",
  );

  const inputItems2: TreeIOs[] = JSON.parse(
    sessionStorage.getItem("modulesInputs") || "{}",
  );

  const webCats: WebsiteCategories[] = JSON.parse(
    sessionStorage.getItem("webcats") || "{}",
  );

  const modules: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}",
  );

  const storedLanguage = (sessionStorage.getItem("language") || "NL")
    .replace(/"/g, "")
    .toUpperCase();
  const selectedLanguage: "NL" | "FR" | "EN" = ["NL", "FR", "EN"].includes(storedLanguage)
    ? (storedLanguage as "NL" | "FR" | "EN")
    : "NL";

  const t = getTranslations();

  const getCategoryLabel = (cat: WebsiteCategories): string => {
    if (selectedLanguage === "FR") {
      return cat.categorie_fr || cat.categorie_nl || cat.categorie_en;
    }

    if (selectedLanguage === "EN") {
      return cat.categorie_en || cat.categorie_nl || cat.categorie_fr;
    }

    return cat.categorie_nl || cat.categorie_fr || cat.categorie_en;
  };

  type ViewType = "uitgangen" | "ingangen" | "ruimtes";
  const prevView = useRef<String>("ruimtes");

  useEffect(() => {
    if (selectedView === "") {
      const key = prevView.current as ViewType;
      setSelectedView(key);
      //debugger
    }
  }, [selectedView]);

  useEffect(() => {
    /*
    const inputItemsFiltereda: kamerItem[] = functions.buildInputsByUitvoering(
      uitvoering,
      inputItems,
    );
    */
   
    const inputItemsFiltereda: kamerItem[] =
      functions.newBuildInputsByUitvoering(uitvoering, inputItems2);

    //setInputItemsFiltered(inputItemsFiltereda);
    setInputItemsFiltered(inputItemsFiltereda);
  }, [uitvoering]);

  useEffect(() => {
    if (outputs.length === 0) {
      setOutputs(outputItems);
    }
    if (inputs.length === 0) {
      setInputs(inputItemsFiltered);
    }
  }, [inputItemsFiltered]);

  useEffect(() => {
    const handler = () => {
      const newOutputItems: kamerItem[] = JSON.parse(
        sessionStorage.getItem("modulesOutputs") || "{}",
      );
      const newInputItems2: TreeIOs[] = JSON.parse(
        sessionStorage.getItem("modulesInputs") || "{}",
      );
      setOutputs(newOutputItems);
      const filteredInputs = functions.newBuildInputsByUitvoering(
        uitvoering,
        newInputItems2,
      );
      setInputItemsFiltered(filteredInputs);
      setInputs(filteredInputs);
    };
    window.addEventListener("databasesReloaded", handler);
    return () => window.removeEventListener("databasesReloaded", handler);
  }, [uitvoering]);

  // Update treeItemsArray when selectedView, inputs, or outputs change
  useEffect(() => {
    //console.log(selectedView);
    if (selectedView === "uitgangen") {
      setTreeItemsArray(myTreeIcons.ioItemArray(outputs));
    } else if (selectedView === "ingangen") {
      setTreeItemsArray(myTreeIcons.ioItemArray(inputs));
    }
  }, [selectedView, inputs, outputs]);

  //const inputItems: kamerItem[] = inputItemsFiltered

  const [, setItemToAddEigenNaam] = useState<boolean>(false);
  const [itemToAddRuimteNaam, setitemToAddRuimteNaam] =
    useState<boolean>(false);
  const [itemToAddIoNaam, setItemToAddIoNaam] = useState<boolean>(true);
  const [itemToAddAantal, setItemToAddAantal] = useState<number>(1);

  const [itemToAddIoNaamText, setItemToAddIoNaamText] = useState<string>("");

  const increaseId = () => {
    const idString = sessionStorage.getItem("nodeId");
    const id = Number(idString);

    if (!isNaN(id)) {
      const newId = id + 1;
      sessionStorage.setItem("nodeId", newId.toString());
    }
  };

  const selectedWoningid = woningSlectedId;

  const safeText = (value: unknown): string => {
    if (value === null || value === undefined) return "";
    return String(value);
  };

  function buildFlatItemsFromInUit(
    ioType: "Uitgangen" | "Ingangen",
    webCats: WebsiteCategories[],
    ios: TreeIOs[],
  ): kamerItem[] {
    const result: kamerItem[] = [];

    webCats
      .filter((cat) => cat.io_type === ioType)
      .sort((a, b) => a.volgorde - b.volgorde)
      .forEach((cat) => {
        const categoryNodeId = String(cat.id);
        const categoryLabel = getCategoryLabel(cat);

        // category node
        result.push({
          nodeid: "io-" + categoryNodeId,
          label: categoryLabel,
          type: "woning",
          parent: undefined, // ⚠ must be undefined for root
          typeIcon: cat.typeIcon,
          moduleType: "category",
          id: "",
          name: categoryLabel,
        });

        // module children
        ios
          .filter((io) => {
            if (ioType === "Uitgangen") return Number(io.webCat) === Number(cat.id);
            if (ioType === "Ingangen") return Number(io.webCat) === Number(cat.id);
            return false; // fallback if ioType is something else
          })
          .sort((a, b) => safeText(a.label).localeCompare(safeText(b.label)))
          .forEach((io) => {
            result.push({
              nodeid: "io-" + String(io.nodeid),
              label: io.label,
              type: io.type,
              parent: "io-" + categoryNodeId, // links to category
              typeIcon: io.typeIcon ?? cat.typeIcon,
              moduleType: io.moduleType,
              id: "",
              name: io.label,
            });
          });
      });

    return result;
  }

  function buildFlatItems(
    ioType: "Uitgangen" | "Ingangen",
    webCats: WebsiteCategories[],
    modules: ModuleTypes[],
  ): kamerItem[] {
    const result: kamerItem[] = [];

    webCats
      .filter((cat) => cat.io_type === ioType)
      .sort((a, b) => a.volgorde - b.volgorde)
      .forEach((cat) => {
        const categoryNodeId = String(cat.id);
        const categoryLabel = getCategoryLabel(cat);

        // category node
        result.push({
          nodeid: "io-" + categoryNodeId,
          label: categoryLabel,
          type: "woning",
          parent: undefined, // ⚠ must be undefined for root
          typeIcon: cat.typeIcon,
          moduleType: "category",
          id: "",
          name: categoryLabel,
        });

        // module children
        modules
          .filter((mod) => {
            if (ioType === "Uitgangen" && mod.obsolete === 0) return Number(mod.webCat) === Number(cat.id);
            if (ioType === "Ingangen" && mod.obsolete === 0) return Number(mod.webCat) === Number(cat.id);
            return false; // fallback if ioType is something else
          })
          .sort((a, b) => safeText(a.name).localeCompare(safeText(b.name)))
          .forEach((mod) => {
            const displayName = MODULE_DISPLAY_NAMES[mod.name] ?? mod.name;

            result.push({
              nodeid: "io-" + String(mod.id),
              label: displayName,
              type: "woning",
              parent: "io-" + categoryNodeId, // links to category
              typeIcon: mod.icon ?? cat.typeIcon,
              moduleType: mod.type,
              id: "",
              name: displayName,
            });
          });
      });

    return result;
  }

  const outputsbycatsdb = buildFlatItems("Uitgangen", webCats, modules);
  const inputsbycatsdb = buildFlatItems("Ingangen", webCats, modules);

  const filteredInputNodeIds = new Set(inputItemsFiltered.map((item) => item.nodeid));
  const filteredInputItemsAsTreeIOs: TreeIOs[] = inputItems2.filter((item) =>
    filteredInputNodeIds.has(item.nodeid),
  );

  const inputItemsbycatsdb = buildFlatItemsFromInUit(
    "Ingangen",
    webCats,
    filteredInputItemsAsTreeIOs,
  );
  const outputItemsbycatsdb = buildFlatItemsFromInUit(
    "Uitgangen",
    webCats,
    outputItems2,
  );

  function getType(
    arr: kamerItem[],
    nodeId: any,
  ): [string, string, string, string] {
    let selLabel = "";
    let selMod = "";
    let selTypeIcon = "";
    let ioName = "";
    let modType = "";

    arr.forEach((treenode) => {
      if (treenode.nodeid === nodeId) {
        selTypeIcon = treenode.typeIcon!;
        selMod = treenode.moduleType!;

        if (ioType === "module") {
          modType = treenode.name || "";
        }

        const parts: string[] = [];

        if (itemToAddRuimteNaam && selectedWoningid.label !== "") {
          parts.push(selectedWoningid.label);
        }

        if (itemToAddIoNaam && treenode.label !== "") {
          parts.push(treenode.label!);
        }

        if (itemToAddIoNaamText !== "") {
          parts.push(itemToAddIoNaamText);
        }

        // Als geen van de naamopties actief is, neem dan altijd de treenode label
        selLabel =
          parts.length > 0 ? parts.join(" - ") : treenode.label || "";
      }
      return "";
    });

    return [selLabel, selMod, selTypeIcon, modType];
  }

  function addIoToDatabase(
    selMod: string,
    selTypeIcon: string,
    selLabel: string,
    outputOptions: outputOptions,
    modType: string,
    forcedAantal?: number,
  ): void {
    let moduletype: string = outputOptions.moduletype ?? "";
    if (selMod === "category") return;

    let type = "";
    type = selMod;

    if (ioType === "io") {
      if (selMod.includes("SWC") || selMod.includes("MDI")) {
        type = `${selMod}/${uitvoering}`;
      } else {
        type = selMod;
      }

      if (type === "SWC01/NNB" || type === "SWC02/NNB") {
        type = "SWC0102/NNB";
      }
      if (type === "SWC01T/NNB" || type === "SWC02T/NNB") {
        type = "SWC0102T/NNB";
      }
    }
    let aant = 1;
    let type2Check = type;

    // If Op/Neer (rolluik op relais -> change type to relais)

    const isRoloVariant =
      String(type || "").toUpperCase().startsWith("ROLO") ||
      selTypeIcon === "rol";

    if (isRoloVariant) {
      //type = "REL" // Added in new version to put ROLs on REL
      type2Check = "REL";
    }

    if (ioType === "io") {
      const configuredIoCount = isRoloVariant
        ? getConfiguredIoOutputCount("ROLO") ?? 2
        : getConfiguredIoOutputCount(type);
      if (configuredIoCount) {
        aant = configuredIoCount;
      }
    }

    const retMod = functions.checkMod(type2Check);

    if (!retMod.found) {
      setErrorMessage(t.moduleBestaatNiet);
      setErrorsVisible(true);
      return;
    }

    // Keep persisted item type aligned with DbModules.type to support legacy aliases.
    type = retMod.moduleType || type;

    // If ioType === "module": check aantal outputs on module
    //console.log(functions.getIosOnMod(modType))
    if (ioType === "module") {
      // Map display name back to real module name before storing in outputOptions.
      moduletype = MODULE_REAL_NAMES[modType] ?? modType;

      const iosOnMod = Number(
        functions.getIosOnMod(moduletype) || functions.getIosOnMod(`${moduletype}/DEC`),
      );
      const configuredModuleCount =
        getConfiguredIoOutputCount(moduletype) ??
        getConfiguredIoOutputCount(type);
      //aant = itemToAddAantal * Number(iosOnMod);
      if (ADD_MAX_OUTPUTS_PER_MODULE) {
        if (iosOnMod > 0) {
          aant = iosOnMod;
        } else {
          const outputsFromName = Number(
            (String(moduletype).match(/(\d{2})(?!.*\d)/)?.[1] ?? "0"),
          );
          if (outputsFromName > 0) {
            aant = outputsFromName;
          }
        }
      } else if (configuredModuleCount) {
        // Apply moduleAlias exceptions in module view (e.g. INP2, INP4, RED).
        aant = configuredModuleCount;
      }
    }

    const countToUse = Number(forcedAantal ?? itemToAddAantal);
    if (ioType === "module") {
      aant = aant * countToUse;
    } else if (countToUse !== 1) {
      aant = aant * countToUse;
    }
    let items: dbItem[] = [];

    for (let i = 0; i < aant; i++) {
      const label = aant > 1 ? `${selLabel} ${i + 1}` : selLabel;
      let mynodeId = sessionStorage.getItem("nodeId")?.toString() || "";
      //if (mynodeId === "") {mynodeId = "0"}
      const dbItem: dbItem = {
        nodeid: mynodeId,
        label,
        type,
        parent: selectedWoningid.id,
        typeIcon: selTypeIcon,
        outputOptions: {
          ...outputOptions,
          moduletype,
        },
        //moduletype: modType,
      };
      const item2add = { item: dbItem, parent: selectedWoningid.id };
      items.push(dbItem);
      increaseId();
    }
    //debugger
    // Here we sent items to opbouw -> add to db
    addToParentDb(items);
  }

  // On Input or Output item clicked
  // -> Add item to database
  const onIOItemClicked = (event: React.SyntheticEvent, nodeId: string) => {
    if (selectedWoningid.type === "woning") {
      let arr: kamerItem[] = [];
      let group: string = "";

      let whatToLoad: string = selectedView;

      if (selectedView === "uitgangen") {
        whatToLoad = "uitgangen";
      } else if (selectedView === "ingangen") {
        whatToLoad = "ingangen";
      }

      switch (whatToLoad) {
        case "uitgangen":
          if (ioType === "io") {
            arr = outputItemsbycatsdb;
          } else if (ioType === "module") {
            arr = outputsbycatsdb;
          }
          break;
        case "ingangen":
          if (ioType === "io") {
            arr = inputItemsbycatsdb;
          } else if (ioType === "module") {
            arr = inputsbycatsdb;
          }
          break;
        default:
      }

      // We only get the node id here, so search the clicked node in list and return props
      const [selLabel, selMod, selTypeIcon, modType] = getType(arr, nodeId);

      if (ioType === "module") {
        group = modType;
      }

      setMyNodeId(nodeId);

      if (selMod === "DMX") {
        dmxAantalRef.current = itemToAddAantal;
        setDmxVisible(true);
      } else if (selMod === "DALIM") {
        qdmAantalRef.current = itemToAddAantal;
        setQdmVisible(true);
      } else {
        // Here we finally add our selected io to the main database
        const outputOptions: outputOptions = {
          dmxType: "",
          qdmType: "",
          ctdId: Number(ctdId),
          kastId: Number(kastId),
          moduletype: group,
        };
        addIoToDatabase(selMod, selTypeIcon, selLabel, outputOptions, modType);
      }
    } else {
      setErrorMessage(t.geenRuimteGekozen);
      setErrorsVisible(true);
    }
  };

  const addRuimte = (): void => {
    const dbItem: dbItem = {
      nodeid: sessionStorage.getItem("nodeId")?.toString() || "",
      label: ruimteNaam,
      type: "woning",
      parent: selectedWoningid.id,
      typeIcon: "floor",
      //moduletype: "",
      outputOptions: { dmxType: "", ctdId: 0, kastId: 0, moduletype: "" },
    };

    let items = [];
    items.push(dbItem);

    addToParentDb(items);
    increaseId();

    // Clear inputs
    setRuimteNaam("");
    setNaamText("");
  };

  const onNaamChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    setRuimteNaam(value);
  };

  const onNameKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      addRuimte();
    }
  };

  const renderRuimtes = () => (
    <Form.Group>
      <Form.Label>{t.geefNaamRuimte}</Form.Label>
      <Form.Control
        id="ruimtenaam"
        name="ruimtenaam"
        aria-describedby=""
        onChange={onNaamChange}
        onKeyDown={onNameKeyPress}
        value={ruimteNaam}
      />
      <Button onClick={addRuimte}>{t.voegRuimteToe}</Button>
    </Form.Group>
  );

  const createIoTrees = (parents: kamerItem[] = []) => {
    const raw = myTreeIcons.handleParentArray(parents);
    const kamerArray: kamerItem[] = Array.isArray(raw) ? raw : [raw]; // ✅ Type-safe array
    const selItems = "ioNode_" + selectedView;

    const renderTree = (node: kamerItem): React.ReactNode => (
      <TreeItem
        className="treeitem_buildingtree"
        key={node.nodeid}
        nodeId={node.nodeid}
        label={node.name}
        icon={node.icon}
        sx={{ overflowX: "hidden", fontSize: 18 }}
        onContextMenu={(e) => showMenu(e, node)}
      >
        {node.children?.map((child: kamerItem) => renderTree(child))}
      </TreeItem>
    );

    return (
      <TreeView
        className="treeview_buildingtree"
        aria-label="customized"
        key={selItems + treeItemCounter.current++}
        expanded={parents.map((p) => p.nodeid)}
        sx={{ overflowX: "hidden" }}
        onNodeSelect={onIOItemClicked}
      >
        {kamerArray.map((rootNode: kamerItem) => renderTree(rootNode))}
      </TreeView>
    );
  };

  const IOTree = (whatToLoad: string) => {
    let itemsToLoad: kamerItem[] = [];

    switch (whatToLoad) {
      case "uitgangen":
        if (ioType === "io") {
          itemsToLoad = outputItemsbycatsdb;
        } else if (ioType === "module") {
          itemsToLoad = outputsbycatsdb;
        }
        break;
      case "ingangen":
        if (ioType === "io") {
          itemsToLoad = inputItemsbycatsdb;
        } else if (ioType === "module") {
          itemsToLoad = inputsbycatsdb;
        }
        break;
      default:
    }

    // Extract unique parents
    const parents: kamerItem[] = [];
    itemsToLoad.forEach((treenode) => {
      if (!parents.includes(treenode)) {
        parents.push(treenode);
      }
    });

    const sortedArray = parents.sort(
      (a, b) => parseInt(a.nodeid, 10) - parseInt(b.nodeid, 10),
    );

    // Collect trees by category moduleType
    const compArray = sortedArray.reduce<React.ReactNode[]>((acc, treetype) => {
      if (treetype.moduleType === "category") {
        const catArra = myTreeIcons.getItemsByCat(sortedArray, treetype.nodeid);
        acc.push(createIoTrees(catArra));
      }
      return acc;
    }, []);

    const CustomFontTheme = createTheme({
      typography: { fontSize: 11 },
    });

    return (
      <ThemeProvider theme={CustomFontTheme}>
        {compArray.map((node, idx) => (
          <React.Fragment key={idx}>{node}</React.Fragment>
        ))}
      </ThemeProvider>
    );
  };

  // Set view (ruimte's, uitgangen, ingangen)
  const handleClick = (eventKey: any) => {
    //console.log(eventKey);
    const key = `${eventKey}` as ViewType;
    if (["uitgangen", "ingangen", "ruimtes"].includes(key)) {
      setSelectedView(key);
    }
  };

  const handleErrorScreen = (visible: boolean) => {
    setErrorsVisible(visible);
  };

  const handleDmxScreen = (dmxVisible: boolean, id: number) => {
    setDmxVisible(dmxVisible);
    // BugFix: if DMX screen is closed with "OK" we need to add the selected DMX type to the database, so we use the id that is returned from the DMX screen to do so
    // *** set type and typeIcon based on dmx type ***
    // Replace with correct value depending on how selectedWoningid is stored
    const woningTreeSelectedType = selectedWoningid.type;

    if (woningTreeSelectedType === "woning") {
      let arr: kamerItem[] = [];

      if (selectedView === "uitgangen") {
        arr = ioType === "module" ? outputsbycatsdb : outputItemsbycatsdb;
        setTreeItemsArray(myTreeIcons.ioItemArray(outputs));
      } else if (selectedView === "ingangen") {
        arr = ioType === "module" ? inputsbycatsdb : inputItemsbycatsdb;
        setTreeItemsArray(myTreeIcons.ioItemArray(inputs));
      }

      const [selLabel, selMod, selTypeIcon, modType] = getType(arr, myNodeId);

      let group = "";
      if (ioType === "module") {
        group = modType;
      }

      const dmxTypeLabels: Record<number, string> = {
        1: "Dimmer",
        4: "RGB",
        6: "RGBW",
        8: "KwWw",
      };
      const dmxTypeSuffix = dmxTypeLabels[id] ? ` - ${dmxTypeLabels[id]}` : "";
      const labelWithDmxType = selLabel + dmxTypeSuffix;

      const outputOptions = {
        dmxType: String(id),
        ctdId: Number(ctdId),
        kastId: Number(kastId),
        moduletype: group,
      };

      const dmxCount = dmxAantalRef.current;
      addIoToDatabase(
        selMod,
        selTypeIcon,
        labelWithDmxType,
        outputOptions,
        modType,
        dmxCount,
      );
    } else {
      setErrorMessage(t.geenRuimteGekozen);
      setErrorsVisible(true);
    }
  };

  const handleDmxSelect = (dmxId: string): void => {
    console.log(dmxId);
  };

  const handleQdmScreen = (
    qdmVisible: boolean,
    qdmType: "individual" | "group",
    fixtureCount: number,
  ) => {
    setQdmVisible(qdmVisible);

    const woningTreeSelectedType = selectedWoningid.type;

    if (woningTreeSelectedType === "woning") {
      let arr: kamerItem[] = [];

      if (selectedView === "uitgangen") {
        arr = ioType === "module" ? outputsbycatsdb : outputItemsbycatsdb;
        setTreeItemsArray(myTreeIcons.ioItemArray(outputs));
      } else if (selectedView === "ingangen") {
        arr = ioType === "module" ? inputsbycatsdb : inputItemsbycatsdb;
        setTreeItemsArray(myTreeIcons.ioItemArray(inputs));
      }

      const [selLabel, selMod, selTypeIcon, modType] = getType(arr, myNodeId);

      let group = "";
      if (ioType === "module") {
        group = modType;
      }

      const qdmCount = qdmAantalRef.current;

      // Add a single group or individual address item.
      // For group items, fixtureCount is stored on the item so calculations can
      // reserve the corresponding individual addresses without adding extra visible items.
      const addressSuffix = qdmType === "group"
        ? ` - ${t.qdmGroup ?? "Group"}`
        : ` - ${t.qdmIndividual ?? "Individual"}`;

      addIoToDatabase(
        selMod,
        selTypeIcon,
        selLabel + addressSuffix,
        {
          dmxType: "",
          qdmType,
          qdmFixtureCount: qdmType === "group" ? fixtureCount : 0,
          ctdId: Number(ctdId),
          kastId: Number(kastId),
          moduletype: group,
        },
        modType,
        qdmCount,
      );
    } else {
      setErrorMessage(t.geenRuimteGekozen);
      setErrorsVisible(true);
    }
  };

  const handleQdmSelect = (qdmType: "individual" | "group"): void => {
    console.log(qdmType);
  };

  const HandleNameChange = (naam: string) => {
    setItemToAddIoNaamText(naam);
  };

  const HandleAantalOutputsChange = (aantal: number) => {
    setItemToAddAantal(aantal);
  };

  const HandleonEigenNaamCheckChange = (check: boolean) => {
    setItemToAddEigenNaam(check);
  };

  const HandleUitgangNaamCheckChange = (check: boolean) => {
    setItemToAddIoNaam(check);
  };

  const HandleRuimtenNaamCheckChange = (check: boolean) => {
    setitemToAddRuimteNaam(check);
  };

  function showMenu(event: any, item: kamerItem) {
    event.preventDefault();
    event.stopPropagation();
    const positionChange = {
      x: event.clientX,
      y: event.clientY,
    };
    setxyPosition(positionChange);
    setContextItem(item);
    //setContext(true)
  }

  function closeConetxt() {
    setContext(false);
  }

  const handleIOType = (event: any, ioType: string) => {
    setioType(ioType);
  };

  function ButtonGroup() {
    return (
      <ToggleButtonGroup
        className="io-buttons"
        value={ioType}
        exclusive
        onChange={handleIOType}
      >
        <ToggleButton value="io" sx={{ ml: 1 }}>
          I/O
        </ToggleButton>

        <ToggleButton value="module">module</ToggleButton>
      </ToggleButtonGroup>
    );
  }
  
  return (
    <>
      <Card className="card_buildingtree" style={{ height: "95vh" }}>
        <CardHeader>
          <Nav
            variant="pills"
            defaultActiveKey="/home"
            onSelect={handleClick}
            activeKey={selectedView}
          >
            <Nav.Item>
              <Nav.Link eventKey="ruimtes" className="building-nav">
                {t.ruimtes}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="uitgangen" className="building-nav">
                {t.uitgangen}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="ingangen" className="building-nav">
                {t.ingangen}
              </Nav.Link>
            </Nav.Item>

            <ButtonGroup />
          </Nav>
        </CardHeader>

        {selectedView !== "ruimtes" ? (
          <IoName
            onNameChange={HandleNameChange}
            onAantalChange={HandleAantalOutputsChange}
            onEigenNaamCheckChange={HandleonEigenNaamCheckChange}
            onUitgangNaamCheckChange={HandleUitgangNaamCheckChange}
            onRuimtenNaamCheckChange={HandleRuimtenNaamCheckChange}
          />
        ) : (
          ""
        )}
        <CardBody className="card_mods_body">
          {selectedView === "ruimtes" ? renderRuimtes() : ""}

          {selectedView === "uitgangen" ? IOTree("uitgangen") : ""}
          {selectedView === "ingangen" ? IOTree("ingangen") : ""}
        </CardBody>
      </Card>

      <Errors
        visible={errorsVisible}
        message={errorMessage}
        onDataChange={handleErrorScreen}
      />

      <DmxOptions
        visible={dmxVisible} //{this.state.dmxVisible}
        onDmxClose={handleDmxScreen}
        onDmxSelect={handleDmxSelect}
      />

      <QdmOptions
        visible={qdmVisible}
        onQdmClose={handleQdmScreen}
        onQdmSelect={handleQdmSelect}
      />

      <ModulesContext
        visible={context}
        position={xyPosition}
        item={contextItem}
        onClose={closeConetxt}
      />
    </>
  );
};

export default OutputModulesTree;
